module.exports = __webpack_public_path__ + "media/packs/images/flags/LT-a07523f832bf0369c5b5a246036f02bf.svg";